"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _IconSVG = _interopRequireDefault(require("../components/IconSVG"));
var _excluded = ["size", "title", "ariaHidden"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var pathSizesToPaths = {
  "16": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M9.287 2.456c0-.75-.61-1.36-1.36-1.36a1.362 1.362 0 0 0 0 2.72c.75 0 1.36-.61 1.36-1.36Zm.35 1.618h1.431v1H4.786v-1h1.432a2.346 2.346 0 0 1-.65-1.618 2.363 2.363 0 0 1 2.36-2.36 2.363 2.363 0 0 1 2.36 2.36c0 .627-.25 1.195-.652 1.618ZM13.22 8.37l2.438 2.397-.7.713-1.254-1.232c-.223 3.145-2.75 5.653-5.778 5.653-3.006 0-5.519-2.471-5.773-5.58l-1.106 1.158-.724-.69 2.31-2.42 2.437 2.398-.702.713-1.197-1.18c.224 2.386 2.018 4.29 4.256 4.545V5.658h1v9.188c2.207-.251 3.981-2.108 4.244-4.452l-1.034 1.084-.724-.69 2.308-2.42Z"
  }),
  "24": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M14.193 3.472c0-1.268-1.032-2.3-2.3-2.3a2.303 2.303 0 0 0-2.3 2.3c0 1.268 1.031 2.3 2.3 2.3 1.268 0 2.3-1.032 2.3-2.3Zm-.216 2.699h2.748v1.125H7.06V6.17h2.748a3.41 3.41 0 0 1-1.34-2.699A3.429 3.429 0 0 1 11.892.047a3.429 3.429 0 0 1 3.426 3.425 3.41 3.41 0 0 1-1.34 2.699Zm6.067 6.695 3.602 3.542-.789.801L20.609 15c-.113 4.938-4.02 8.954-8.716 8.954-4.667 0-8.55-3.966-8.71-8.862l-2.026 2.122-.814-.777 3.407-3.57 3.602 3.542-.79.801-2.26-2.223c.099 4.125 3.197 7.506 7.028 7.812v-14.4h1.125v14.399c3.797-.303 6.87-3.629 7.021-7.706l-2.025 2.121-.814-.777 3.407-3.57Z"
  }),
  "32": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M18.923 4.63a3.07 3.07 0 0 0-3.067-3.067 3.07 3.07 0 0 0-3.067 3.067 3.07 3.07 0 0 0 3.067 3.067 3.07 3.07 0 0 0 3.067-3.067Zm-.287 3.597H22.3v1.5H9.412v-1.5h3.664c-1.08-.837-1.787-2.13-1.787-3.598A4.572 4.572 0 0 1 15.856.064a4.572 4.572 0 0 1 4.567 4.567c0 1.468-.708 2.76-1.787 3.597Zm8.09 8.928 4.801 4.722-1.052 1.069-2.997-2.947c-.15 6.584-5.36 11.939-11.622 11.939-6.223 0-11.4-5.289-11.614-11.817l-2.7 2.83-1.086-1.036L5 17.155l4.802 4.722-1.052 1.069-3.015-2.965c.133 5.5 4.264 10.009 9.372 10.416V11.199h1.5v19.198c5.062-.404 9.16-4.838 9.361-10.275l-2.7 2.829-1.085-1.036 4.543-4.76Z"
  }),
  "48": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M23.751 1.873c-2.68 0-4.86 2.18-4.86 4.86s2.18 4.86 4.86 4.86 4.861-2.18 4.861-4.86-2.18-4.86-4.861-4.86Zm3.625 10.526h6.162v1.872H13.965V12.4h6.162a6.729 6.729 0 0 1-3.109-5.666A6.74 6.74 0 0 1 23.751 0a6.74 6.74 0 0 1 6.734 6.733 6.73 6.73 0 0 1-3.11 5.666Zm12.886 13.645 7.146 7.025-1.313 1.335-4.892-4.81c0 .223-.002.401-.002.442C40.99 39.94 33.163 48 23.75 48c-9.41 0-17.239-8.059-17.449-17.966l-.002-.263-4.434 4.645-1.354-1.293 6.757-7.08 7.146 7.026-1.313 1.335-4.93-4.847c0 .222.002.4.002.44.182 8.56 6.667 15.564 14.64 16.08V16.71h1.873v29.367c7.976-.516 14.46-7.52 14.642-16.081v-.129l.001-.135-4.47 4.684-1.356-1.293 6.758-7.08Z"
  }),
  "64": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M31.668 2.497a6.488 6.488 0 0 0-6.48 6.48 6.488 6.488 0 0 0 6.48 6.481 6.489 6.489 0 0 0 6.482-6.48 6.489 6.489 0 0 0-6.482-6.481Zm4.833 14.035h8.216v2.496H18.62v-2.496h8.216c-2.489-1.598-4.145-4.384-4.145-7.555C22.69 4.027 26.718 0 31.668 0s8.978 4.027 8.978 8.977c0 3.171-1.658 5.957-4.145 7.555Zm17.181 18.193 9.528 9.368-1.75 1.78-6.523-6.414-.003.589C54.654 53.255 44.216 64 31.668 64 19.12 64 8.682 53.255 8.403 40.046a31.994 31.994 0 0 1-.003-.352l-5.913 6.194-1.805-1.723 9.01-9.44 9.527 9.368-1.751 1.78-6.572-6.463c0 .295.002.532.002.586.243 11.412 8.889 20.752 19.521 21.44V22.28h2.497v39.156c10.634-.688 19.28-10.028 19.522-21.442l.001-.17v-.182l-5.96 6.246-1.807-1.723 9.01-9.44Z"
  })
};
var pathSizesToViewBox = {
  "16": "0 0 16 16",
  "24": "0 0 24 24",
  "32": "0 0 32 32",
  "48": "0 0 48 48",
  "64": "0 0 64 64"
};
var sizesToPathSizes = {
  "16": "16",
  "24": "24",
  "32": "32",
  "48": "48",
  "64": "64"
};
var sizes = ['16', '24', '32', '48', '64'];
var IconBoatAccessories = function IconBoatAccessories(_ref) {
  var _ref$size = _ref.size,
    sizeProp = _ref$size === void 0 ? '32' : _ref$size,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Boat Accessories' : _ref$title,
    _ref$ariaHidden = _ref.ariaHidden,
    ariaHidden = _ref$ariaHidden === void 0 ? false : _ref$ariaHidden,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var size = sizes.indexOf(sizeProp) !== -1 ? sizeProp : '32';
  return /*#__PURE__*/_react.default.createElement(_IconSVG.default, (0, _extends2.default)({
    width: size,
    height: size,
    viewBox: pathSizesToViewBox[sizesToPathSizes[size]],
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    role: "img",
    title: title,
    ariaHidden: ariaHidden
  }, props, {
    iconClass: "BoatAccessories"
  }), pathSizesToPaths[sizesToPathSizes[size]]);
};
IconBoatAccessories.sizes = [16, 24, 32, 48, 64];
IconBoatAccessories.propTypes = {
  /** Available sizes: 16, 24, 32, 48, 64. In most cases, the size will be a square (e.g., 32px X 32px), but height variances can occur. */
  size: _propTypes.default.oneOf(sizes),
  /** Similar to the 'alt' attribute on image tags, this is optional for custom tooltips and will default to the icon name if not overriden. */
  title: _propTypes.default.string,
  /** Hide icon from screen readers. */
  ariaHidden: _propTypes.default.bool,
  /** Optional custom class. */
  className: _propTypes.default.string
};
var _default = IconBoatAccessories;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@lmig/design-system-icons-react/_cjs/boat/BoatAccessories.js
// module id = 1959
// module chunks = 0